import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

import ReactGA from 'react-ga4';

import App from 'Containers/App';
import { configureStore } from 'Redux/store';
import styles from './App.less';

if (process.env.BUGSNAG_API_KEY) {
	Bugsnag.start({
		apiKey: process.env.BUGSNAG_API_KEY,
		appVersion: process.env.APP_VERSION,
		plugins: [new BugsnagPluginReact()]
	});
}

if (process.env.GOOGLE_ANALYTICS_MEASUREMENT_ID) {
	ReactGA.initialize(process.env.GOOGLE_ANALYTICS_MEASUREMENT_ID);
	ReactGA.send('pageview');
}

const MainApp = () => (
	isMobile ? (
		<div className="uk-text-center">
			<div className={ styles.logoContainer }>
				<img src="/assets/images/logo.png" className={ styles.logo } />
			</div>
			<h3 className={ styles.text }>This site is unavailable on mobile</h3>
		</div>
	) : (
		<Provider store={ configureStore() }>
			<Router>
				<Switch>
					<Route path='/' component={App} />
				</Switch>
			</Router>
		</Provider>
	)
);

const ErrorBoundary = process.env.BUGSNAG_API_KEY ? Bugsnag.getPlugin('react').createErrorBoundary(React) : Fragment;

export default ReactDOM.render(
	<ErrorBoundary>
		<MainApp />
	</ErrorBoundary>,
	document.getElementById('root')
);